module.exports = __webpack_public_path__ + "81b9a7b3537bb1ac55e2fea26b10eef4.svg";